/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiConsentStatusDataSchema = z.object({
	consentRequired: z.boolean(),
	agentStopsAt: z.string().nullable(),
})

export type WhatsAppAiConsentStatusDataSchema = z.infer<typeof whatsAppAiConsentStatusDataSchema>
